<!-- მხოლოდ მაშინ ჩანს, თუ PWA ინსტალაცია შესაძლებელია -->

<div *ngIf="showInstallButton">
    <!-- <button class="close-install " (click)="close()"><app-icon iconName="close" width="25" height="25"></app-icon></button> -->
    <button class="install-btn" (click)="installPwa()">{{ 'INSTALL_APP' | translate }}</button>
</div>
